import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'material-ui/FontIcon';
import IconButton from 'material-ui/IconButton';
import _ from 'lodash';
import DataTables from 'material-ui-datatables';

import {
  isStageComplete,
  isStageInProgress,
  toArray,
  sortByLocation,
  sortStrings,
  formatLocation,
  contains,
  getOrderDirection,
} from '../../utils/helper';
import icons from '../../utils/icons';
import { hasPermission } from '../../utils/authenticated';

import styles from './styles';

const hasImages = (task) => {
  console.log('task', task);
  return (task.images && _.keys(task.images).length > 0) ||
    _.values(task.items || {}).find((item) => item.images && _.keys(item.images).length > 0) ||
    _.values(task.stages || {}).find((stage) => stage.qa && stage.qa.questions && _.values(stage.qa.questions).find((question) => question.images && _.values(question.images).length));
};

const renderStageStatus = (task, stage) => {
  if (isStageComplete(task, stage)) {
    return (<FontIcon className="material-icons" style={styles.stageComplete}>done</FontIcon>);
  } else if (isStageInProgress(task, stage)) {
    return (<FontIcon className="material-icons" style={styles.stagePending}>autorenew</FontIcon>);
  }

  return (<FontIcon className="material-icons" style={styles.stageNotStarted}>clear</FontIcon>);
};

const getTableColumns = (stages = [], editable, onEdit, onRemove, onViewImages) => {
  return _.flatten([
    {
      key: 'origin',
      label: 'Origin',
      render: (origin) => formatLocation(origin),
      sortable: true,
    }, {
      key: 'destination',
      label: 'Destination',
      render: (destination) => formatLocation(destination),
      sortable: true,
    }, {
      key: 'contact',
      label: 'Contact',
      render: (contact) => <span>{contact ? contact.name : ''}</span>,
      sortable: true,
    },
    stages.map((stage) => {
      return {
        key: stage.id,
        label: stage.icon ? <img src={icons[stage.icon]} style={styles.stageIcon} alt={stage.name}/> : stage.name,
        render: (a, task) => renderStageStatus(task, stage),
        style: styles.taskStageCol,
      };
    }),
    {
      key: 'action',
      label: '',
      render: (a, task) => {
        return (<span>{ editable ? <IconButton
          tooltip="Edit"
          tooltipPosition="bottom-center"
          onClick={(evt) => {
            evt.stopPropagation();
            onEdit(task);
          }}>
          <FontIcon
            className='material-icons'
            style={styles.icon}
          >edit</FontIcon>
        </IconButton> : null }
          { editable ? <IconButton
            tooltip="Remove"
            tooltipPosition="bottom-center"
            onClick={(evt) => {
              evt.stopPropagation();
              onRemove(task);
            }}
          >
            <FontIcon
              className="material-icons"
              style={styles.icon}
            >delete</FontIcon>
          </IconButton> : null }
          { onViewImages && hasImages(task) ? <IconButton
            tooltip="Photos"
            tooltipPosition="bottom-center"
            onClick={(evt) => {
              evt.stopPropagation();
              onViewImages(task);
            }}
          >
            <FontIcon
              className="material-icons"
              style={styles.icon}
            >photo</FontIcon>
          </IconButton> : null }</span>);
      },
      sortable: true,
      style: styles.actionCol,
    },
  ]);
};

const ORIGIN_SORT = (a, b) => sortByLocation(a.origin, b.origin);
const DESTINATION_SORT = (a, b) => sortByLocation(a.destination, b.destination);
const CONTACT_SORT = (a, b) => sortStrings(a.contact ? a.contact.name : '', b.contact ? b.contact.name : '');

const getSorter = (sorter = (a, b) => 0, order = 'asc') => {
  return (a, b) => {
    let result = sorter(a, b) * getOrderDirection(order);

    if (result === 0) {
      result = ORIGIN_SORT(a, b);

      if (result === 0) {
        result = DESTINATION_SORT(a, b);

        if (result === 0) {
          result = CONTACT_SORT(a, b);
        }
      }
    }

    return result;
  };
};

const getTaskFilter = (filter) => {
  return (task) => {
    if (filter) {
      let result = task.contact ? contains(task.contact.name, filter) : false;

      if (!result && task.origin) {
        const location = formatLocation(task.origin);
        result = contains(location, filter);
      }

      if (!result && task.destination) {
        // result = contains(task.destination.building, filter) ||
        //   contains(task.destination.floor, filter) ||
        //   contains(task.destination.space, filter);
        const location = formatLocation(task.destination);
        result = contains(location, filter);
      }

      return result;
    }

    return true;
  };
};

class TasksTable extends Component {
  static propTypes = {
    selectable: PropTypes.bool,
    multiSelectable: PropTypes.bool,
    onEdit: PropTypes.func,
    onRemove: PropTypes.func,
    onViewImages: PropTypes.func,
    onRowSelection: PropTypes.func,
    job: PropTypes.object.isRequired,
    tasks: PropTypes.object.isRequired,
  };

  state = {
    page: 1,
    limit: 10,
    sortBy: getSorter(),
    data: [],
  };

  componentWillMount() {
    const allTasks = toArray(this.props.tasks);
    console.log('this.props.tasks', this.props.tasks);
    console.log('setting data - 1');
    this.setState({
      editable: hasPermission(['JobCreator', 'Administrator']),
      allTasks,
      data: allTasks.filter((task) => !task.deleted).sort(this.state.sortBy),
    });
  }

  componentWillReceiveProps(nextProps) {
    const allTasks = toArray(nextProps.tasks);
    const { filter } = this.state;
    console.log('setting data - 2', filter);
    this.setState({
      allTasks,
      data: allTasks.filter((task) => !task.deleted).filter(getTaskFilter(filter ? filter.trim().toLowerCase() : '')).sort(this.state.sortBy),
    });
  }

  handleFilterValueChange = (filter) => {
    const { page, limit, sortBy, allTasks } = this.state;

    const data = allTasks.filter((task) => !task.deleted).filter(getTaskFilter(filter ? filter.trim().toLowerCase() : '')).sort(sortBy);
    console.log('filter change', data.length);
    console.log('setting data - 3');
    this.setState({
      page: Math.min(page, Math.floor(data.length / limit) + 1),
      data,
      filter,
    });
  };

  handleSortOrderChange = (key, order) => {
    let sortBy = getSorter();
    switch (key) {
      case 'origin':
        sortBy = getSorter(ORIGIN_SORT, order);
        break;
      case 'destination':
        sortBy = getSorter(DESTINATION_SORT, order);
        break;
      case 'contact':
        sortBy = getSorter(CONTACT_SORT, order);
        break;
      default:
        break;
    }

    const { filter, allTasks } = this.state;
    console.log('setting data - 4');
    this.setState({
      data: allTasks.filter((task) => !task.deleted).filter(getTaskFilter(filter ? filter.trim().toLowerCase() : '')).sort(sortBy),
      sortBy,
    });
  };

  handlePreviousPageClick = () => {
    this.setState({
      page: Math.max(1, this.state.page - 1),
    });
  };

  handleNextPageClick = () => {
    const { data, page, limit } = this.state;

    this.setState({
      page: Math.min(Math.ceil(data.length / limit), page + 1),
    });
  };

  handleRowSizeChange = (a, limit) => {
    this.setState({
      limit,
      page: 1,
    });
  };

  handleRowSelection = (evt) => {
    console.log('setting data - 8');
    let selectedRows = [];
    switch (evt) {
      case 'all':
        selectedRows = _.range(0, Math.min(this.state.limit, this.state.data.length));
        break;
      case 'none':
        selectedRows = [];
        break;
      default:
        selectedRows = evt;
        break;
    }

    this.setState({
      selectedRows,
    });

    if (this.props.onRowSelection) {
      const { limit, page, data } = this.state;
      const items = data.slice((page - 1) * limit, page * limit);
      this.props.onRowSelection(selectedRows, items.filter((item, idx) => selectedRows.indexOf(idx) >= 0));
    }
  };

  renderNoData() {
    return (<div style={styles.noDataRow}>
      <FontIcon className="material-icons" style={styles.noData}>transform</FontIcon>
      <div>No tasks are available</div>
    </div>);
  }

  render() {
    const { job, onEdit, onRemove, onViewImages } = this.props;
    const { editable, page, limit, data } = this.state;

    if (!data || data.length === 0) {
      return this.renderNoData();
    }

    return (<DataTables
      height={'auto'}
      selectable={this.props.selectable}
      multiSelectable={this.props.multiSelectable}
      enableSelectAll={this.props.multiSelectable}
      selectedRows={this.state.selectedRows}
      showRowHover
      columns={getTableColumns((job.profile || {}).stages, editable, onEdit, onRemove, onViewImages)}
      data={data.slice((page - 1) * limit, page * limit)}
      showCheckboxes={this.props.selectable}
      onFilterValueChange={this.handleFilterValueChange}
      onSortOrderChange={this.handleSortOrderChange}
      onPreviousPageClick={this.handlePreviousPageClick}
      onNextPageClick={this.handleNextPageClick}
      onRowSizeChange={this.handleRowSizeChange}
      onRowSelection={this.handleRowSelection}
      page={page}
      rowSize={limit}
      count={data.length}
      filterHintText="Filter"
      headerToolbarMode="filter"
      showHeaderToolbar
    />);
  }

}

export default TasksTable;



// WEBPACK FOOTER //
// ./src/components/TasksTable/index.js